import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import UnderConstruction from "../../components/underConstruction/UnderConstruction";

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <UnderConstruction />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
